import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import * as actions from '../actions/Grants';
import DeleteConfirmation from '../components/MultiDeleteConfirmation';
import GridHeader from '../components/common/GridHeader';
import moment from 'moment';
import Breadcrumb from '../components/AdminBreadcrumb';
import { DataGrid } from '@mui/x-data-grid';


const Grants = (props) => {
    const [deleteConfirmationState, setDeleteConfirmationState] = useState({
        display: false,
        toDelete: [],
    });
    const [deleteEnabled, setDeleteEnabled] = useState(false);
    const location = useLocation(); 
    const myProp = location.state?.myProp;

    useEffect(() => {
        if (myProp === 'fromMenu')
            props.actions.getGrants();
    }, []);


    const handleSelect = (e) => {
        props.actions.getGrant(e.id);
        props.history.push(`/grants/grant/${e.id}`, { id: e.id })
    };

    const handleNewGrant = () => {
        props.actions.newGrant();
        props.history.push('/grants/grant');
    }

    const handleDelete = () => {
        props.actions.deleteGrants(deleteConfirmationState.toDelete.map(x => x.grantId));
        setDeleteConfirmationState({
            display: false,
            toDelete: [],
        });
    }

    const handleDeleteConfirmationToggle = () => setDeleteConfirmationState({
        display: !deleteConfirmationState.display,
        toDelete: deleteConfirmationState.toDelete
    });

    const handleDeleteClick = (e) => {
        setDeleteConfirmationState({
            display: true,
            toDelete: deleteConfirmationState.toDelete
        });
    }

    const handleSelectionChanged = (e) => {
        if (e.length > 0) {
            setDeleteConfirmationState({
                display: false,
                toDelete: props.grants.filter(x => e.find(y => y === x.get('grantId'))).toJS(),
            });
            setDeleteEnabled(true);
        }
        else
            setDeleteEnabled(false);
    }

    return (
        <Container>
            <div style={{ paddingBottom: '10px' }}>
                <Breadcrumb history={props.history} />
            </div>
            <Row className='mb-1'>
                <GridHeader
                    gridEntities='Grants'
                    deleteButtonId='deleteGrantButton'
                    disableDelete={!deleteEnabled}
                    onDeleteClick={handleDeleteClick}
                    addButtonId='addGrantButton'
                    onAddClick={handleNewGrant}
                    addTooltipTarget={'addGrantButton'}
                    deleteTooltipTarget={'deleteGrantButton'}
                    tooltipEntity={'Grant'}
                />
            </Row>
            <Row className='mb-1'>
                <Col>
                    <div className='ag-theme-balham' style={{ width: 'auto' }}>
                        <DataGrid
                            rows={props.grants.toJS().map(x => { return { id: x.grantId, ...x } })}
                            checkboxSelection
                            onRowDoubleClick={handleSelect}
                            onRowSelectionModelChange={handleSelectionChanged}
                            autoHeight={true}
                            rowHeight={35}
                            initialState={{
                                pagination: { paginationModel: { pageSize: 25 } },
                            }}
                            columns={[
                                {
                                    headerName: 'Name',
                                    field: 'name',
                                    flex: 3,
                                },
                                {
                                    headerName: 'Start Date',
                                    field: 'startDate',
                                    valueFormatter: (params) => moment(params.value).format('MMM Do YYYY'),
                                    flex: 2,
                                },
                                {
                                    headerName: 'End Date',
                                    field: 'endDate',
                                    valueFormatter: (params) => moment(params.value).format('MMM Do YYYY'),
                                    flex: 2,
                                }
                            ]}
                            sx={{
                                backgroundColor: 'white'
                            }}
                            getRowClassName={(params) => 'grid-row'} />
                    </div>
                </Col>
            </Row>
            <DeleteConfirmation
                title={`Delete Grant`}
                onDelete={handleDelete}
                onToggle={handleDeleteConfirmationToggle}
                toDelete={deleteConfirmationState.toDelete.map(x => {
                    const name = x.name || '';
                    return `${name}`;
                })}
                isOpen={deleteConfirmationState.display}
            />
        </Container>
    );
}

function mapStateToProps(state, ownProps) {

    return {
        grants: state.Grants
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators({ ...actions }, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Grants);